// extracted by mini-css-extract-plugin
export default {"sub_header":"SubHeader_sub_header__XGH34","sub_title":"SubHeader_sub_title__oflKO","sub_underline_1":"SubHeader_sub_underline_1__Ymnkk"};